import script from "./LandingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPage.vue?vue&type=script&setup=true&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=17449643&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17449643"]])

export default __exports__